// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .cg-tree-container {
  border-right: 1px solid #e3e3e3;
}
.presize-root .cg-tree-container > div:first-child {
  position: sticky;
  top: 0;
}
/*# sourceMappingURL=Main.css.map */`, "",{"version":3,"sources":["webpack://./Main.less","webpack://./src/pages/Main.less"],"names":[],"mappings":"AAAA;EAEE,+BAAA;ACAF;ADCE;EACE,gBAAA;EACA,MAAA;ACCJ;AACA,mCAAmC","sourcesContent":[".presize-root { \n .cg-tree-container {\n  border-right: 1px solid #e3e3e3;\n  &>div:first-child {\n    position: sticky;\n    top: 0;\n  }\n}\n \n}",".presize-root .cg-tree-container {\n  border-right: 1px solid #e3e3e3;\n}\n.presize-root .cg-tree-container > div:first-child {\n  position: sticky;\n  top: 0;\n}\n/*# sourceMappingURL=Main.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
